<script>
import {mapActions, mapState} from "vuex";
import CardListApplicants from "./CardListApplicants.vue";

export default {
  name: "CardListStatementsV2",
  components: {CardListApplicants},
  props: {
    select_stm_hostel_id: Number,
    department_id: String
  },
  data: () => ({
    headers_table_state: [
      {text: 'ФИО', value: 'full_name', sortable: false},
      {text: 'ПРИЗНАК', value: 'privilege', align: "center", sortable: false, filterable: false},
      {text: 'СТАТУС', value: 'status_commission.status_review', align: "center", sortable: false, filterable: false},
      {text: 'ДАТА ОТПРАВЛЕНИЯ', value: 'created_at', sortable: false, filterable: false},
      {text: 'ДЕЙСТВИЯ', value: 'actions', sortable: false, align: "center", filterable: false},
      // {text: '', value: 'distribute', sortable: false, align: "center", filterable: false}
    ],
    selected_statement: {},
    page: 1,
    pageCount: 0,
    type_statements: null
  }),
  computed: {
    ...mapState({
      distribution_places: state => state.placesInDormitories.distribution_places,
      list_current_statements: state => state.interactionStatement.list_current_statements,
      stm_applicants: state => state.interactionStatement.stm_applicants,
    }),
    data_table() {
      if (this.type_statements === 2){
        return this.stm_applicants?.statements_hostels
      } else {
        return this.list_current_statements
      }
    }
  },
  methods: {
    ...mapActions({
      GetDetailsStatement: 'interactionStatement/GetDetailsStatement',
      GetStatementsForDepartment: 'interactionStatement/GetStatementsForDepartment',
      IndexApplicants: 'interactionStatement/IndexApplicants',
    }),
    async getStudentsStatements() {
      await this.GetStatementsForDepartment(this.department_id)

      this.type_statements = 1
    },
    async getApplicantsStatements() {
      await this.IndexApplicants(this.department_id)

      this.type_statements = 2
    },
    setStatus(current_status) {
      if (current_status === 1) {
        return {color: 'orange', icon: 'fa fa-exclamation-circle'}
      } else if (current_status === 2) {
        return {color: 'green', icon: 'fa fa-check-circle'}
      } else if (current_status === 0) {
        return {color: 'red', icon: 'fa fa-times-circle'}
      }
    },
    transitionStatementDetails(stm_hostel_id) {
      this.GetDetailsStatement(stm_hostel_id)

      this.$emit('setSelectCurrentStmHostel', {
        stm_hostel_id: stm_hostel_id
      })

      this.$emit('transitionStatementDetails')
    }
  },
}
</script>

<template>
  <v-card outlined class="rounded-xl" width="100%" height="100%">
    <v-card-title>
      <h6
          class="mx-auto text-caption text-uppercase text--secondary"
      >
        Список заявлений
      </h6>
    </v-card-title>
    <v-card-text
        style="height: calc(100% - 100px)"
        class="ma-0 pa-0"
    >
      <v-tabs
          class="d-flex justify-center"
          color="teal"
      >
        <v-tabs-slider color="teal"></v-tabs-slider>

        <v-tab @click="getStudentsStatements">Студенты</v-tab>
        <v-tab @click="getApplicantsStatements">Абитуриенты</v-tab>
      </v-tabs>

      <v-data-table
          :headers="headers_table_state"
          :items="data_table"
          :items-per-page="12"
          :page.sync="page"
          :sort-by="['privilege','created_at']"
          :sort-desc="[false, true]"
          loading-text="Загрузка заявлений... пожалуйста подождите"
          @page-count="pageCount = $event"
          no-data-text="По предложенным критериям данные отсутствуют"
          hide-default-footer
          mobile-breakpoint="0"
      >
        <!--              <template v-slot:top>-->
        <!--                <v-app-bar-->
        <!--                    elevation="0"-->
        <!--                >-->
        <!--                  <v-app-bar-nav-icon @click.stop="drawer_left = !drawer_left">-->
        <!--                    <template v-slot:default>-->
        <!--                      <v-icon small>-->
        <!--                        fa-bars-->
        <!--                      </v-icon>-->
        <!--                    </template>-->
        <!--                  </v-app-bar-nav-icon>-->

        <!--                  <v-spacer></v-spacer>-->

        <!--                  <v-text-field-->
        <!--                      v-model="search_table"-->
        <!--                      label="Поиск"-->
        <!--                      dense-->
        <!--                      outlined-->
        <!--                      hide-details-->
        <!--                      clearable-->
        <!--                      @click:clear="search_table = ''"-->
        <!--                  >-->
        <!--                    <template v-slot:prepend>-->
        <!--                      <v-icon size="20px">-->
        <!--                        fa-search-->
        <!--                      </v-icon>-->
        <!--                    </template>-->
        <!--                  </v-text-field>-->
        <!--                </v-app-bar>-->
        <!--              </template>-->
        <template v-slot:item.actions="{ item }">
          <v-btn @click="transitionStatementDetails(item.id)" small icon>
            <v-icon size="15px">
              fa fa-eye
            </v-icon>
          </v-btn>
        </template>
        <template v-slot:item.status_commission.status_review="{ item }">
          <v-icon size="20px" :color="setStatus(item.status_commission.status_review).color">
            {{ setStatus(item.status_commission.status_review).icon }}
          </v-icon>
        </template>
        <template v-slot:item.privilege="{ item }">
          <v-icon
              v-if="item.privilege === 'Отсутствует'"
              size="20px"
          >
            fa-universal-access
          </v-icon>
          <v-icon
              v-else
              size="20px"
              color="green"
          >
            fa-universal-access
          </v-icon>
        </template>
      </v-data-table>

    </v-card-text>
    <v-card-actions v-if="pageCount > 0">
      <v-pagination
          class="mx-auto"
          v-model="page"
          total-visible="8"
          :length="pageCount"
          color="teal"
          circle
      ></v-pagination>
    </v-card-actions>
  </v-card>
</template>

<style scoped>

</style>